import { useEffect, useState } from "react";
import { getApprovedFeedbacks } from "../../utils/api/feedbackApi.js";
import { Link, useLocation } from "react-router-dom";
import { useLanguage } from "../../context/LanguageContext.jsx";

const CONTENT = {
  ne: {
    eyebrow: "समुदायको आवाज",
    pageTitle: "प्रतिक्रियाहरू",
    pageDesc: "हाम्रा प्रयोगकर्ताहरूले दिएका प्रतिक्रियाहरू",
    empty: "अहिलेसम्म कुनै प्रतिक्रिया छैन।",
    submitFeedback: "प्रतिक्रिया दिनुहोस् →",
  },
  en: {
    eyebrow: "Community Voice",
    pageTitle: "Feedbacks",
    pageDesc: "Feedback submitted by our users",
    empty: "No feedback yet.",
    submitFeedback: "Give Feedback →",
  },
};

const FeedbackDisplayPage = () => {
  const location = useLocation();
  const isEditor = location.pathname.startsWith('/editor');

  const { language } = useLanguage();
  const t = CONTENT[language];

  const [feedbacks, setFeedbacks] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getApprovedFeedbacks()
      .then((data) => setFeedbacks(data))
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="min-h-screen font-sans pt-32 py-16 px-6"
      style={{ background: "linear-gradient(135deg, #14532d 0%, #166534 60%, #15803d 100%)" }}>
      <div className="max-w-2xl mx-auto">

        {/* Header */}
        <div className="text-center mb-10">
          <p className="text-xs font-bold tracking-widest uppercase mb-3" style={{ color: "#fb923c" }}>
            {t.eyebrow}
          </p>
          <h1 className="text-4xl font-extrabold text-white mb-3"
            style={{ fontFamily: "'Playfair Display', serif" }}>
            {t.pageTitle}
          </h1>
          <p className="text-green-200 text-sm">
            {t.pageDesc}
          </p>
        </div>

        {/* Loading */}
        {loading && (
          <div className="flex justify-center py-10">
            <svg className="animate-spin h-6 w-6 text-green-300" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z" />
            </svg>
          </div>
        )}

        {/* Empty */}
        {!loading && feedbacks.length === 0 && (
          <div className="rounded-2xl border border-gray-200 p-8 text-center text-gray-400 text-sm bg-white">
            {t.empty}
          </div>
        )}

        {/* Cards */}
        <div className="space-y-4">
          {feedbacks.map((fb) => (
            <div key={fb._id} className="rounded-2xl border border-gray-200 p-6 bg-white">
              {fb.category && (
                <span className="text-xs font-bold uppercase tracking-widest" style={{ color: "#fb923c" }}>
                  {fb.category}
                </span>
              )}
              <p className="text-gray-800 text-sm mt-2 leading-relaxed">{fb.message}</p>
              <p className="text-xs text-gray-400 mt-3">
                {new Date(fb.createdAt).toLocaleDateString(language === "ne" ? "ne-NP" : "en-US")}
              </p>
            </div>
          ))}
        </div>

        {/* Back buttons */}
        <div className="flex justify-center gap-3 mt-8">
          <Link
            to={isEditor ? "/editor/feedback" : "/feedback"}
            className="text-center px-6 py-3 rounded-lg text-white font-semibold text-sm transition-colors"
            style={{ background: "#ea580c", width: "200px" }}>
            {t.submitFeedback}
          </Link>
        </div>

      </div>
    </div>
  );
};

export default FeedbackDisplayPage;